import type { ApiClient, RequestOptions } from './client';
import type { SessionHistoryResponse } from '@/types/chat';

export interface SessionHistoryApi {
  getMessages: (sessionId: string, options?: RequestOptions) => Promise<SessionHistoryResponse>;
}

/**
 * 会话历史。后端是唯一的历史真相——本地不再缓存任何消息。
 *
 * V1 不传 limit / offset，一次拉全量：单会话消息量有限，分页留到
 * `total` 确实变大时再做。
 */
export function createSessionHistoryApi(client: ApiClient): SessionHistoryApi {
  return {
    getMessages(sessionId, options) {
      return client.get<SessionHistoryResponse>(
        `/api/chat/sessions/${encodeURIComponent(sessionId)}/messages`,
        options,
      );
    },
  };
}
